export const PRODUCT_VITRINE_FILTER_MINE = '__mine__';
export const PRODUCT_VITRINE_FILTER_ALL = '__all__';
